var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        title: _vm.$t("home.setFavorites"),
        visible: _vm.setFavoritesItemDialog,
        width: "800px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.setFavoritesItemDialog = $event
        },
      },
    },
    [
      _c("div", [
        _c(
          "div",
          { staticClass: "hasSelect", staticStyle: { "margin-top": "10px" } },
          [_vm._v(_vm._s(_vm.$t("home.selectMenu")))]
        ),
        _c(
          "div",
          { staticStyle: { height: "250px", width: "100%" } },
          [
            _c(
              "el-select",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  placeholder: _vm.$t("customerManagements.SOUrceName"),
                  clearable: "",
                  filterable: "",
                  multiple: "",
                },
                model: {
                  value: _vm.selectMenu,
                  callback: function ($$v) {
                    _vm.selectMenu = $$v
                  },
                  expression: "selectMenu",
                },
              },
              _vm._l(_vm.pcMenuList, function (item, index) {
                return _c("el-option", {
                  key: index,
                  attrs: { label: item.name, value: item.title },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { "text-align": "right" } },
          [
            _c(
              "el-button",
              {
                on: {
                  click: function ($event) {
                    _vm.setFavoritesItemDialog = false
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")) + " ")]
            ),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
              [_vm._v(_vm._s(_vm.$t("changepwd.confirm")))]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }